const ConfigHelper = {
    GraphQlUrl: "https://dev.travelsment.com/graphql",
    Auth0_ClientId: "F1aN0P253OYhj004gc93v9uD5DGCQBtU",
    //Auth0_RoleId: "rol_fN6dHIh21S99Fbid",
    Auth0_Audience: "https://dev-b8dnjx5d.us.auth0.com/api/v2/",
    Auth0_domain: "dev-b8dnjx5d.us.auth0.com",
    ReactGA: "G-RTYR7G1DV3",
    email: 'boris.stambler@yahoo.com',
    subEmail: ['boris.stambler@yahoo.com'],
    base_url: 'https://dev-b8dnjx5d.us.auth0.com',
    base_api: 'https://dev.travelsment.com/api',
    url: 'https://dev.travelsment.com',
    title: "Travelsment"
};

export default ConfigHelper;